import { receiptPrintStyles } from '@/constants'
import axios from 'axios'
import { toast } from 'react-hot-toast'

const printContainerId = 'receipts-print-container'
const printStyleId = 'receipts-print-style'

export async function printOrderTickets({
  organizationSlug,
  orderId,
  cloudprntEnabled,
  printerId,
}: {
  organizationSlug: string
  orderId: number
  cloudprntEnabled: boolean
  printerId: number | null
}) {
  if (cloudprntEnabled) {
    try {
      await axios.post(`/organizations/${organizationSlug}/print_jobs`, { order_id: orderId, printer_id: printerId })
      toast.success("Tickets envoyés à l'imprimante.")
      return
    } catch {
      if (!confirm("Échec de l'envoi à l'imprimante. Imprimer via le navigateur ?")) return
    }
  }

  try {
    const { data } = await axios.get<{ receipts_html: string[] }>(
      `/organizations/${organizationSlug}/orders/${orderId}/receipts`
    )
    await printReceiptsInBrowser(data.receipts_html)
  } catch {
    toast.error("Impossible d'imprimer les tickets.")
  }
}

async function printReceiptsInBrowser(receiptsHtml: string[]) {
  document.getElementById(printContainerId)?.remove()
  document.getElementById(printStyleId)?.remove()

  const style = document.createElement('style')
  style.id = printStyleId
  style.textContent = `${receiptPrintStyles}\n@media print { body > :not(.print-only) { display: none !important; } }`

  const container = document.createElement('div')
  container.id = printContainerId
  container.className = 'print-only'
  container.innerHTML = receiptsHtml.map((html) => `<div class="receipt">${html}</div>`).join('')

  document.head.appendChild(style)
  document.body.appendChild(container)

  const images = Array.from(container.querySelectorAll('img'))
  await Promise.all(images.map((image) => image.decode().catch(() => undefined)))

  const cleanUp = () => {
    container.remove()
    style.remove()
  }
  window.addEventListener('afterprint', cleanUp, { once: true })
  window.print()
}
